<template>
    <footer>
       <h1> Footer </h1>
    </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer{
  background-color: #472383;
  padding:20px;
  text-align:center;
  color:white;
}


</style>
